module.exports = __webpack_public_path__ + "static/media/4.1a58393c.jpg";